import { render, staticRenderFns } from "./UserDetailsAdditionalDataResponseRevisionTable.vue?vue&type=template&id=32b5a104&scoped=true&"
import script from "./UserDetailsAdditionalDataResponseRevisionTable.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsAdditionalDataResponseRevisionTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsAdditionalDataResponseRevisionTable.vue?vue&type=style&index=0&id=32b5a104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5a104",
  null
  
)

export default component.exports